import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { debounceTime } from 'rxjs';
import { PhoneService } from 'src/app/shared/services/phone.service';
import { Phone } from 'src/app/shared/models/phone';
import { STATUS } from 'src/app/shared/phone-utils';

@Component({
  selector: 'app-order-form',
  templateUrl: './order-form.component.html',
  styleUrls: ['./order-form.component.scss']
})
export class OrderFormComponent implements OnInit {

  public form: FormGroup;
  public submitted = false;

  constructor(
    public readonly translate: TranslateService,
    private readonly _formBuilder: FormBuilder,
    private readonly phoneService: PhoneService,
    private spinner: NgxSpinnerService,
  ) {
    this._initFormGroupe();
  }

  ngOnInit(): void {
    let canCheck = true;
    this.form?.controls.imei1.valueChanges.pipe(debounceTime(100)).subscribe((imei: string) => {
      if (/^[0-9]{15}$/.test(imei) && this.form?.value?.model?.length === 0 && canCheck) {
        canCheck = false;
        this.phoneService.checkImei(imei).subscribe(({ object }: any) => {
          this.form.controls.model.setValue(object?.model);
          canCheck = true;
        });
      }
    });
  }

  /**
    * init all the fields of the form Group and add the validation
    */
  private _initFormGroupe() {
    this.form = this._formBuilder.group({
      customerFullName: ['', Validators.required],
      imei1: ['', [Validators.required, Validators.pattern('^[0-9]*$'), Validators.minLength(15), Validators.maxLength(15)]],
      imei2: ['', [Validators.pattern('^[0-9]*$'), Validators.minLength(15), Validators.maxLength(15)]],
      serialNumber: ['', Validators.required],
      model: ['', Validators.required],
      phoneNumber: ['', Validators.required],
      mail: [''],
      status: [STATUS.inPreparation, Validators.required],
      createdAt: [new Date(), Validators.required],
      updatedAt: [new Date(), Validators.required],
    });
  }


  // convenience getter for easy access to form fields
  get formControls() { return this.form.controls; }

  /**
  * Submit the form values
  */
  public async onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.form.invalid) { return }
    this.spinner.show();
    const phone = Object.assign(new Phone(), this.form.value);
    this.phoneService.save(phone).subscribe((phone: Phone) => {
      this.spinner.hide();
      this.form.reset();
    })
    this.submitted = false;
  }
}
